const SAVE = 'SAVE_CART';

export function cartReducer (state = [], action) {
    switch (action.type) {
        case SAVE:
            return action.payload;
        default:
            return state;
    }
}